import {
  Box,
  Checkbox,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import FdTextField from "../../components/UIComponents/TextField/FdTextfield";
import { useContext, useEffect, useState } from "react";
import { StoreContext } from "../../store/Store";
import ISessionLocation from "../../dataProvider/interfaces/ISessionLocation";
import { theme } from "../../theme";
import { IReservationDetail } from "./AssignReservations";
import { reservationClasses as classes } from "./style";

export interface IManageReservationProps {
  item: any;
  isChecked: boolean;
  handleItemSelect: Function;
  index: number;
  checkedItems: IReservationDetail[];
  handleAmountChange: Function;
}

export const ManageReservationForm = (props: IManageReservationProps) => {
  const {
    item,
    isChecked,
    handleItemSelect,
    index,
    checkedItems,
    handleAmountChange,
  } = props;
  const [state] = useContext(StoreContext);
  const [amount, setAmount] = useState(item?.defaultRestrictAccessAmount);
  useEffect(() => {
    const fetchAmount = () => {
      const i_ = checkedItems?.findIndex(
        (el: { sessionId: any }) => el.sessionId === item.id
      );
      if (i_ !== -1) {
        setAmount(checkedItems?.[i_]?.sessionAmount);
      }
    };
    fetchAmount();
  }, [checkedItems]);
  const fetchLocationWithID = () => {
    const locationId = item.location;
    const location = state.sessionLocations.filter(
      (location: ISessionLocation) => location.id === locationId
    )[0];
    return `${location?.name || item["sessionLocation"] || ""}`;
  };

  return (
    <ListItem
      sx={{
        backgroundColor: index % 2 ? "#fff" : theme.palette.grey[600],
        cursor: "default",
        "&:hover": {
          background: theme.palette.primary.main,
          "& .MuiListItemText-root .MuiTypography-root, & .MuiCheckbox-root": {
            color: "#fff",
          },
        },
      }}
    >
      <ListItemIcon sx={{ minWidth: "initial", pr: 1 }}>
        <Checkbox
          // {...register("checkSession")}
          checked={isChecked}
          onChange={() => handleItemSelect(item.id, amount)}
          onClick={(e) => {
            e.stopPropagation();
          }}
          sx={{ pl: 0 }}
          disableRipple
        />
      </ListItemIcon>

      <ListItemText
        primary={item.name}
        primaryTypographyProps={classes.listTextCss}
        secondary={fetchLocationWithID()}
        secondaryTypographyProps={{
          component: "span",
          fontSize: "14px",
          display: "inline-block",
        }}
      />
      <FdTextField
        sx={{ width: "100px" }}
        value={amount === -1 ? "INFINITY" : amount}
        onChange={(e: any) => {
          setAmount(e.target.value);
          handleAmountChange?.(e, item.id);
        }}
        disabled={amount === -1}
        type="text"
        defaultValue={"1"}
      />
    </ListItem>
  );
};
